import styled, { CSSObject } from 'styled-components';

export const defaultBodyStyle: CSSObject = {};
export const TableBody = styled.tbody(defaultBodyStyle);
